export default Object.freeze({
  appointment_unavailable: 'appointment_unavailable',
  assign: 'assign',
  cancel: 'cancel',
  reject: 'reject',
  reject_ticket: 'reject_ticket'
})
